import '../Dashboard/Default/TabLots/LotsTable.css'

export const renderHeaderCell = (
  col,
  idx,
  colorFilter,
  toggleDateFilterVisibility,
  t
) => {
  const isDate = col.DataType === "date";
  const onClick = isDate ? toggleDateFilterVisibility : undefined;

  return (
    <th 
      key={`header-${idx}`}
      className="style_thead_th"
      style={{
        backgroundColor: colorFilter,
        cursor: col.cursor || isDate ? "pointer" : "default",
        width: "100px",
      }}
      onClick={onClick}
      colSpan={col.colSpan || 1}
    >
      {t(col.label)}
    </th>
  );
};
